import React, { Component } from 'react';
import templateData, { localsMessages } from '../../utility/getTemplateData';
import {
  handleGuestCountryChange,
  hideSpinnerOverlay,
  showSpinnerOverlay,
} from '../../utility/helper';
import * as FPT from '../../utility/fpt';
import * as DonateAppActions from '../../actions/AppActions';
import $ from 'jquery';
import { getInitialData } from '../../utility/formator';
import AppStore from '../../stores/AppStore';
import { getParametersFromUrl } from '../../utility/queryStringHelper';
import PropTypes from 'prop-types';

const initialData = getInitialData();
const serviceErrorMessages = localsMessages('errors/service');

function withDonate(WrappedComponent) {
  return class extends Component {
    static propTypes = {
      history: PropTypes.object,
    };

    constructor(props) {
      super(props);
    }

    handleCountryChange = (country) => {
      this.toggleSpinner(true);

      if (country !== initialData.selectedCountry) {
        DonateAppActions.changeCountry({
          country: country,
        });

        // Beacons for country change
        FPT.trackLinkClickWithData('changeCountry', { country: country });

        let { token, signUp = false } = templateData;
        let url = signUp
          ? `/donate?token=${token}&signup=true&country.x=${country}&locale.x=${country}`
          : `/donate?token=${token}&country.x=${country}&locale.x=${country}&countryChange=true&clientState=/donate/guest?token=${token}`;

        handleGuestCountryChange(url);
      }
    };

    /*
     * showing and hiding spinner
     */
    toggleSpinner = (isSpinner = false) => {
      if (isSpinner) {
        showSpinnerOverlay();
      } else {
        hideSpinnerOverlay();
      }
    };

    // handles scrolling screen to the error
    handleScrollToError = () => {
      let errorEl = $(
        '.vx_has-error-with-message:visible, .service_error_holder:visible'
      );
      $('html, body').animate(
        { scrollTop: errorEl.offset() && errorEl.offset().top },
        1000
      );
      return;
    };

    getDonateGuestUrl = () => {
      const { token, country, language } = templateData;

      let url = `/donate/guest?token=${token}`;
      if (country) {
        url = url + `&country.x=${country}`;
      }

      if (country && language) {
        url = url + `&locale.x=${country}_${language}`;
      }

      return url;
    };

    getFormData() {
      return AppStore.getFormData();
    }

    saveFormData(formData) {
      DonateAppActions.saveFormData(formData);
    }

    showErrorOnLoad() {
      const url = window.location.href;
      let params = getParametersFromUrl(url);

      if (params.showErrorOnLoad) {
        if (params.showErrorOnLoad === 'fulfillment') {
          // TODO: update error code to the actual fullfilment error code
          let errorCode = 'WSM_TRANSACTION_FAILED_DUE_TO_INVALID_CARD_DATA';
          let errorMsgs = [
            {
              key: 0,
              value: serviceErrorMessages[errorCode],
            },
          ];

          // adding delay to wait for the dispatcher to get registered in ServerErrors
          setTimeout(
            () =>
              DonateAppActions.updateServerErrors({ serverErrors: errorMsgs }),
            250
          );
        }
        // delete params.showErrorOnLoad;

        // const query = $.param(params);
        // const cleanedUrl = `/donate/guest/?${query}`;
        // window.history.replaceState({}, document.title, cleanedUrl);
      }
    }

    doFulfilment = (params = {}) => {
      const { securityCode } = params;
      this.toggleSpinner(true);

      $.post(
        '/donate/guest/fullfilment',
        {
          note: AppStore.getDonationNote(),
          fundingOptionId: AppStore.getFundingOptions().id,
          email: AppStore.getEmail(),
          billingAddress: AppStore.getBillingAddress(),
          giftAidItFlag: AppStore.getGiftaidItFlagStatus() || false,
          card: { securityCode },
        },
        (result) => {
          if (result.code === 'WSM_PAYMENT_DENIED') {
            this.toggleSpinner(false);
            this.props.history.push('/donate/error/payment');
            return;
          } else if (result.status === 'redirect') {
            this.toggleSpinner(false);
            window.location.href = result.url;
            return;
          } else if (
            result.code === 'WSM_TRANSACTION_FAILED_DUE_TO_INVALID_CARD_DATA'
          ) {
            // fulfillment error
            const { token, country } = templateData;

            let clientState = encodeURIComponent(
              `/donate/guest?token=${token}&showErrorOnLoad=fulfillment`
            );
            window.location.href = `/donate?token=${token}&country.x=${country}&locale.x=${country}&clientState=${clientState}`;
            return;
          } else if (result.data && result.data.confirmationData) {
            this.toggleSpinner(false);
            let confirmationData = result.data.confirmationData || {};
            DonateAppActions.updateConfirmation({
              confirmation: confirmationData,
            });

            if (confirmationData.isOfacPending) {
              this.props.history.push('/donate/guest/pending');
            } else {
              this.props.history.push('/donate/guest/confirmation');
            }
          } else {
            this.toggleSpinner(false);
            this.props.history.push('/donate/error/payment');
          }
        }
      ).fail(() => {
        this.toggleSpinner(false);
        this.props.history.push('/donate/error/payment');
      });
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          handleCountryChange={this.handleCountryChange}
          toggleSpinner={this.toggleSpinner}
          handleScrollToError={this.handleScrollToError}
          getDonateGuestUrl={this.getDonateGuestUrl}
          getInitialFormData={this.getInitialFormData}
          getFormData={this.getFormData}
          saveFormData={this.saveFormData}
          showErrorOnLoad={this.showErrorOnLoad}
          doFulfilment={this.doFulfilment}
        />
      );
    }
  };
}

export default withDonate;
